<template>
  <!--
    @name: detail.vue
    @description: 直播详情页面
    @author:  GaoYu
    @time: 2020/7/14 15:36
  -->
  <div class="live-detail-container">
    <div class="fixed-top">
      <HeaderWithBtnTwo :app-url="appUrl"></HeaderWithBtnTwo>
      <!--播放器-->
      <div
        class="live-player"
        :style="{ backgroundImage: 'url(' + detail.pc_banner + ')' }"
      >
        <div class="video" v-show="isPlay">
          <my-video ref="video"></my-video>
          <div class="live-count-down" v-show="liveNotStart && liveTimeText">
            {{ liveTimeText }}
          </div>
          <div class="popularity-num" v-show="liveIng && popularityShow == 1">
            当前 {{ popularityNum }} 人气
          </div>
          <div class="playback-ad-count-down" v-show="playbackAdCountDown > 0">
            <span class="second">{{ playbackAdCountDown }}</span> 秒
          </div>
        </div>

        <div class="live-text-box" v-show="!isPlay && !videoIsPay">
          <div class="live-text center">{{ liveTimeText }}</div>
        </div>

        <!--回放付费-->
        <div class="playback-pay" v-show="!isPlay && videoIsPay">
          <img
            src="https://dianyuan-public.oss-cn-shenzhen.aliyuncs.com/static/live/xiaomeng.png"
            alt=""
            class="playback-pay-img"
          />
          <p>添加客服微信</p>
          <p>开通完整课程</p>
        </div>
      </div>
    </div>
    <div class="empty"></div>
    <!--打开APP按钮-->
    <!-- App 打开，可交流、互动、抽红包 -->
    <div
      class="btn-box"
      :style="{
        bottom:
          liveNotStart && detail.h5_live_apply_type === 2 ? '73px' : '35px'
      }"
    >
      <go-app :app-url="appUrl">
        <van-button type="primary">点击查看：PPT、提问、答疑、红包</van-button>
      </go-app>
      <!-- <div class="btn-text">还有收藏、关注、资料下载更多功能等你发现</div> -->
    </div>
    <!--广告-->
    <div class="ad-box" v-show="detail.ad_image !== ''">
      <a :href="detail.ad_link ? detail.ad_link : 'javascript:void(0)'"
        ><img :src="detail.ad_image" alt=""
      /></a>
    </div>

    <!--多讲师标题-->
    <theme-title></theme-title>

    <!--直播介绍-->
    <div class="introduce-box">
      <div
        class="introduce-item"
        v-for="(item, index) in detail.app_content"
        :key="index"
      >
        <div class="introduce-text" v-if="item.cont_type === 1">
          {{ item.content }}
        </div>
        <div class="introduce-img" v-if="item.cont_type === 2">
          <img :src="item.content" alt="" />
        </div>
      </div>
    </div>

    <!--报名按钮-->
    <div class="bottom-btn-box" v-show="liveNotStart">
      <div class="luckdraw" v-if="detail.h5_live_apply_type === 1">
        <a :href="detail.h5_live_apply_link"><img :src="actImg" alt=""/></a>
      </div>
      <div class="appointment-btn" v-else-if="detail.h5_live_apply_type === 2">
        <a :href="detail.h5_live_apply_link">预约直播</a>
      </div>
    </div>

    <!--登录-->
    <login-dialog ref="login"></login-dialog>
  </div>
</template>

<script>
import HeaderWithBtnTwo from "@/components/Common/HeaderWithBtnTwo";
import GoApp from "@/components/Common/GoApp";
import LoginDialog from "@/components/Login/LoginDialog";
import ThemeTitle from "@/components/Live/ThemeTitle";
import MyVideo from "@/components/Common/MyVideo";

import { formatSeconds } from "@/utils/tools";

import { getNewLiveDetailApi, getLiveShareApi } from "@/api/live";
import { actImg } from "@/utils/image";

import huanxinSdk from "easemob-websdk";
import huanxinConf from "@/config/webim.config.js";
export default {
  name: "LiveDetail",
  data() {
    return {
      liveId: this.$route.params.live_id,
      detail: {},
      actImg: actImg,
      isPlay: false,
      popularityNum: 0,
      playbackAdDuration: 0,
      playbackAdDurationCurrent: 0,
      popularityShow: 2 // 1就是显示  2就是不显示
    };
  },
  computed: {
    appUrl() {
      let stat = this.detail.status;
      if (
        stat === this.$config.live.status_nostart &&
        this.detail.count_down <= this.$config.live.count_down
      ) {
        stat = this.$config.live.status_liveing;
      }
      return "eestar://eestar/live?live_id=" + this.liveId + "&status=" + stat;
    },
    videoIsPay() {
      if (this.detail.playback_online !== 1) {
        return false;
      }
      return this.detail.video_type === 2 || this.detail.is_apply === 1;
    },
    liveTimeText() {
      if (this.livePlayback && this.detail.playback_online !== 1) {
        if (this.detail.playback_day === 0) {
          return "该直播暂不支持回放";
        }
        return this.detail.playback_day > 7
          ? "直播已结束，回放会尽快上线"
          : `直播已结束，回放${this.detail.playback_day}天后上线`;
      } else if (this.liveNotStart || this.liveIng) {
        if (this.detail.count_down < this.$config.live.count_down) {
          return "即将开始 " + this.format(this.detail.count_down);
        } else {
          return this.detail.live_time_text + " 直播";
        }
      }
      return "";
    },
    liveNotStart() {
      if (this.detail.count_down > 0) {
        return true;
      } else {
        return false;
      }
    },
    liveIng() {
      if (
        this.detail.count_down < 0 &&
        this.detail.status !== this.$config.live.status_playback
      ) {
        return true;
      } else {
        return false;
      }
    },
    livePlayback() {
      if (this.detail.status === this.$config.live.status_playback) {
        return true;
      } else {
        return false;
      }
    },
    playbackAdCountDown() {
      return this.playbackAdDuration - this.playbackAdDurationCurrent;
    }
  },
  components: {
    HeaderWithBtnTwo,
    GoApp,
    LoginDialog,
    ThemeTitle,
    MyVideo
  },
  mounted() {
    this.getLiveDetail();
    this.getLiveShare();
  },
  methods: {
    goAppFun() {
      this.$refs.goApp.openApp();
    },
    format(val) {
      val = parseInt(val);
      if (val <= this.$config.live.count_down) {
        return formatSeconds(val);
      } else {
        let hour = val / 3600;
        if (hour < 1) {
          // 不到1小时显示分钟
          return Math.round(val / 60) + " 分钟";
        }
        if (hour <= 24) {
          return Math.round(hour) + " 小时";
        }
        return Math.round(hour / 24) + " 天";
      }
    },
    getLiveShare() {
      getLiveShareApi({
        live_id: this.$route.params.live_id,
        url: window.location.href
      }).then(res => {
        if (res.code === this.$config.codeOk) {
          this.liveShareInfo = res.data.liveShareInfo;
          this.weixin = res.data.weixin;
          let that = this;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: that.weixin.appid, // 必填，公众号的唯一标识，填自己的！
            timestamp: that.weixin.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
            nonceStr: that.weixin.nonceStr, // 必填，生成签名的随机串
            signature: that.weixin.signature, // 必填，签名，见附录1
            jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"]
          });
          wx.ready(function() {
            // 分享给朋友
            wx.updateAppMessageShareData({
              title: that.liveShareInfo.title,
              desc: that.liveShareInfo.desc,
              link: window.location.href,
              imgUrl: that.liveShareInfo.share_thum_image_url,
              type: "",
              dataUrl: "",
              success: function() {
                console.log("分享成功");
              }
            });
            // 分享朋友圈
            wx.updateTimelineShareData({
              title: that.liveShareInfo.title,
              link: window.location.href,
              imgUrl: that.liveShareInfo.share_thum_image_url,
              success: function() {
                console.log("分享成功");
              }
            });
          });
        }
      });
    },
    getLiveDetail() {
      getNewLiveDetailApi({
        live_id: this.liveId
      }).then(res => {
        if (res.code === this.$config.codeOk) {
          this.detail = res.data;
          this.popularityNum = res.data.popularity_num;
          this.popularityShow = res.data.popularity_show;
          // this.$refs.login.liveBefore(this.detail.live_before_activity_url)
          // 2023年1月11日 因为直播需要填写问卷,PC端需要,电子星球不需要了

          this.$refs.login.liveBefore("");

          this.countDownTime();

          this.initHuanxin();
        }
      });
    },
    countDownTime() {
      if (this.liveNotStart) {
        // 未开始直播
        if (
          this.detail.count_down <= this.detail.live_star_ad_play_time &&
          this.detail.live_ad_video_url !== ""
        ) {
          // 如果剩余时间小于广告播放时间，开始播放广告
          this.playAd();
        }
        let interval = setInterval(() => {
          if (this.detail.count_down >= 0) {
            this.detail.count_down--;
            if (
              this.detail.count_down <= this.detail.live_star_ad_play_time &&
              this.detail.live_ad_video_url !== ""
            ) {
              // 如果剩余时间小于广告播放时间，开始播放广告
              this.playAd();
            }
          } else {
            // 倒计时结束，开始直播
            this.playLive();
            clearInterval(interval);
          }
        }, 1000);
      } else if (this.liveIng) {
        // 正在直播
        this.playLive();
      } else if (this.livePlayback) {
        // 结束直播
        this.starPlayback();
      }
    },
    playAd() {
      if (this.isPlay || !this.detail.live_ad_video_url) {
        return false;
      }
      this.isPlay = true;
      this.$refs.video.createPlayer({
        videoType: this.detail.video_type,
        cover: this.detail.pc_banner,
        source: this.detail.live_ad_video_url
      });
    },
    playLive() {
      if (!this.detail.pull_hls) {
        return false;
      }
      this.isPlay = true;
      this.$refs.video.createPlayer({
        isLive: true,
        videoType: this.detail.video_type,
        rePlay: false,
        cover: this.detail.pc_banner,
        source: this.detail.pull_hls
      });
    },
    playPlayback() {
      this.isPlay = true;
      this.$refs.video.createPlayer({
        videoType: this.detail.video_type,
        isProcess: true,
        isRate: true,
        rePlay: false,
        cover: this.detail.pc_banner,
        source: this.detail.video
      });
    },
    starPlayback() {
      if (!this.detail.video || this.detail.playback_online !== 1) {
        return false;
      }
      this.isPlay = true;
      if (
        this.detail.is_backplay_ad === 1 &&
        this.detail.live_playback_ad_video_url !== ""
      ) {
        // 回放有广告
        this.$refs.video.createPlayer({
          rePlay: false,
          videoType: this.detail.video_type,
          cover: this.detail.pc_banner,
          source: this.detail.live_playback_ad_video_url
        });
        this.$refs.video.player.on("ready", () => {
          this.playbackAdDuration = parseInt(
            this.$refs.video.player.getDuration()
          );
          this.playbackAdDurationCurrent = parseInt(
            this.$refs.video.player.getCurrentTime()
          );
          let playbackAdInterval = setInterval(() => {
            if (this.playbackAdCountDown <= 0) {
              this.playPlayback();
              clearInterval(playbackAdInterval);
            } else {
              this.playbackAdDurationCurrent = parseInt(
                this.$refs.video.player.getCurrentTime()
              );
            }
          }, 1000);
        });
      } else {
        this.playPlayback();
      }
    },
    startLiveEndAd() {
      if (this.liveEnd || !this.liveIng) {
        return false;
      }
      if (this.detail.live_ad_video_url !== "") {
        this.liveEnd = true;
        setTimeout(() => {
          this.$refs.video.createPlayer({
            rePlay: true,
            videoType: this.detail.video_type,
            cover: this.detail.pc_banner,
            source: this.detail.live_ad_video_url
          });
        }, 200);
      } else {
        this.$refs.video.destroyPlayer();
        this.detail.status = this.$config.live.status_playback;
      }
    },
    initHuanxin() {
      // 环信初始化
      let WebIM = (window.WebIM = huanxinSdk);
      WebIM.config = huanxinConf;
      // 环信实例
      this.conn = WebIM.conn = new WebIM.connection({
        appKey: WebIM.config.appkey,
        isHttpDNS: WebIM.config.isHttpDNS,
        isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
        https: WebIM.config.https,
        url: WebIM.config.xmppURL,
        apiUrl: WebIM.config.apiURL,
        isAutoLogin: true,
        heartBeatWait: WebIM.config.heartBeatWait,
        autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
        autoReconnectInterval: WebIM.config.autoReconnectInterval,
        isStropheLog: WebIM.config.isStropheLog,
        delivery: WebIM.config.delivery
      });
      // 环信事件监听
      this.conn.listen({
        onOpened: message => {
          // 连接成功回调
          console.log("连接环信成功");
          this.conn.joinChatRoom({
            roomId: this.detail.huanxin_room_id, // 聊天室id
            success: function() {
              console.log("加入聊天室成功");
            }
          });
        },
        onTextMessage: message => {
          // 收到文本消息
          if (this.detail.huanxin_room_id !== message.to) {
            return false;
          }
          if (message.ext.type == "4") {
            // 观看人数
            this.popularityNum = message.data;
          } else if (message.ext.type == "5") {
            // 直播结束
            this.startLiveEndAd();
          }
        },
        onPresence: message => {
          // 处理“广播”或“发布-订阅”消息，如联系人订阅请求、处理群组、聊天室被踢解散等消息
        },
        onOnline: () => {
          // 本机网络连接成功
          console.log("本机网络连接成功");
        },
        onOffline: () => {
          // 本机网络掉线
          console.log("本机网络掉线");
        },
        onError: message => {
          // 失败回调
          console.log("失败回调:");
          console.log(message);
        }
      });
      // 登录环信
      this.conn.open({
        apiUrl: WebIM.config.apiURL,
        user: this.detail.huanxin_username,
        pwd: this.detail.huanxin_password,
        appKey: process.env.HUANXIN_APP_KEY
      });
    }
  }
};
</script>

<style lang="less" scoped>
.live-detail-container {
  .center {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .fixed-top {
    background-color: #ffffff;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    .live-player {
      width: 100%;
      height: 211px;
      background-color: #000000;
      background-size: 100% 100%;
      opacity: 0.9;
      .video {
        width: 100%;
        height: 100%;
        position: relative;
        .live-count-down {
          position: absolute;
          left: 50%;
          top: 12px;
          margin-left: -65px;
          width: 130px;
          height: 24px;
          background: rgba(0, 0, 0, 0.59);
          border-radius: 30px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          line-height: 24px;
          z-index: 2000;
        }
        .popularity-num {
          position: absolute;
          top: 10px;
          left: 10px;
          color: #fff;
          padding: 3px 14px;
          background: #000;
          border-radius: 15px;
          opacity: 0.6;
          font-size: 12px;
        }
        .playback-ad-count-down {
          position: absolute;
          left: 50%;
          top: 12px;
          transform: translateX(-50%);
          width: 50px;
          height: 24px;
          line-height: 24px;
          background: rgba(0, 0, 0, 0.59);
          border-radius: 30px;
          font-size: 12px;
          color: #ff6600;
          text-align: center;
          .second {
            color: #ffffff;
          }
        }
      }
      .live-text-box {
        background-color: #000000;
        opacity: 0.8;
        width: 100%;
        height: 100%;
        position: relative;
        .live-text {
          width: 100%;
          height: 20px;
          font-size: 20px;
          line-height: 20px;
          font-weight: 500;
          color: #ffffff;
          text-align: center;
          letter-spacing: 1.2px;
        }
      }
      .playback-pay {
        background-color: #000000;
        width: 100%;
        height: 100%;
        color: #fff;
        font-size: 13px;
        text-align: center;
        .playback-pay-img {
          width: 100px;
          margin: 40px auto 5px;
        }
      }
    }
  }
  .empty {
    height: 260px;
  }

  /*打开App的按钮*/
  .btn-box {
    width: 100%;
    position: fixed;
    left: 50%;
    transform: translate(-50%);
    z-index: 100;
    /deep/.van-button {
      padding: 0 26px;
      width: auto;
      height: 40px;
      display: block;
      background: rgba(117, 58, 183, 1);
      box-shadow: 0 0 5px 0 rgba(117, 58, 183, 1);
      border-radius: 20px;
      border: none;
      outline: none;
      margin: 0 auto;
      font-size: 13px;
      .van-button__text {
        display: block;
      }
    }
    .btn-text {
      margin: 10px 0;
      height: 18px;
      font-size: 13px;
      font-weight: 400;
      color: #999999;
      line-height: 18px;
      text-align: center;
    }
  }
  /*广告框*/
  .ad-box {
    padding: 0 16px;
    overflow: hidden;
    margin-bottom: 10px;
    a,
    img {
      display: block;
      width: 100%;
    }
  }
  /*直播介绍*/
  .introduce-box {
    width: 100%;
    .introduce-text {
      width: 100%;
      box-sizing: border-box;
      font-size: 15px;
      font-weight: 500;
      color: #333333;
      user-select: text;
      word-break: break-all;
    }
    .introduce-img {
      width: 100%;
      img {
        display: block;
        width: 100%;
      }
    }
  }

  /*底部按钮*/
  .bottom-btn-box {
    .luckdraw {
      width: 85px;
      height: 92px;
      position: fixed;
      right: 0;
      top: 80%;
      z-index: 100;
      transform: translate(0, -50%);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .appointment-btn {
      width: 100%;
      height: 48px;
      background: #2cb055;
      position: fixed;
      bottom: 0;
      left: 0;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      line-height: 48px;
      text-align: center;
      a {
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/live/detail.vue